import { axiosKeys, flowKeys, routeKeys, storeKeys, commonKeys, apolloKeys } from 'ui/data/constants/keys';
import {
  addDateFormatting,
  consoleLogs,
  fetchFormFactory,
  getStoreState,
  checkBoolean,
  getDMSProperties,
  setStoreState,
  loadDataFromStorage,
  executeQuery,
  logAPIErrorData,
  getApolloClient,
  GRAPHQL_QUERIES,
  TransactionTypeMaster,
  save,
  fetchActionConfig,
  fetchQueriesAndFragments,
  fetchRoleAuthorization,
  fetchValidation,
  loadPassivePolicies,
  triggerNotificationShared,
  setData,
  setPolicy,
  callAPI,
  loadMastersByContainer,
  fetchUISchemaByFlow,
  setUserRole,
  currencyFormat,
  currencyFormatWithoutDecimal,
  getAgentsAgenciesUW,
  generateDocument,
  logoutUser,
  resetPolicy,
  getUsersData,
} from '@cogitate/ui-multi-utils';
import jsonata from 'jsonata';
import NProgress from 'nprogress';
import {
  AccountHubPolicyStatusMaster,
  PolicyStatusMaster,
  RenewalsPolicyStatusMaster,
  TransactionStatusMaster,
} from 'ui/data/constants/status';
import moment from 'moment';
import { masterModalHelper } from 'ui/redux/actions';
import { LOAD_ACCOUNTHUB_DATA } from 'ui/redux/action-types/helperActionTypes';
import { alertMsgs } from 'ui/data/constants/messages';
import { getInitialState } from 'ui/components/initialData';
import { AddDefaultValues } from './AddDefaultValues';
// import { getChildLOBS } from 'ui/redux/actions/commercial/auto';
import { toast } from 'react-toastify';
// import hasFeature from 'ui/hooks/hasFeature';
import nProgress from 'nprogress';
import { stripPayrollProtectionRiskQualifiersUiFields } from 'ui/utilities/commercial/payrollprotection/practitionerAge';

export const getCurrentLine = () => {
  const selectedBusinessLine = getStoreState(storeKeys.ApplicationReducer).selectedBusinessLine;
  return `${selectedBusinessLine?.line}` || '';
};

export const keepSchemaState = (flow) => {
  const lobSpecificData = getStoreState(storeKeys.ApplicationReducer).selectedBusinessLine;
  const { line, lob, state, carrier, version } = lobSpecificData || {};

  const flowsToKeepSet = new Set(['modals', 'accounthub', 'policyservicing', flow]);
  const schemaState = getStoreState(storeKeys.SchemaReducer);

  if (!schemaState || !line || !lob || !state || !carrier || !version) {
    console.error('Invalid schema state or missing parameters');
    return;
  }

  const versionState = schemaState[line]?.[lob]?.[state]?.[carrier]?.[version];
  if (versionState) {
    Object.keys(versionState).forEach((key) => {
      if (!flowsToKeepSet.has(key)) {
        delete versionState[key];
      }
    });
  }

  setStoreState(storeKeys.SchemaReducer, {
    ...schemaState,
    [line]: {
      ...schemaState[line],
      [lob]: {
        ...schemaState[line]?.[lob],
        [state]: {
          ...schemaState[line]?.[lob]?.[state],
          [carrier]: {
            ...schemaState[line]?.[lob]?.[state]?.[carrier],
            [version]: versionState,
          },
        },
      },
    },
  });
};

export const getCurrentLob = () => {
  const selectedBusinessLine = getStoreState(storeKeys.ApplicationReducer).selectedBusinessLine;
  return `${selectedBusinessLine?.lob}` || '';
};

export const showHidePremiumHelper = (summary, versionPolicy, loggedInUserDetails) => {
  let _showPremium = true;
  if (
    summary.Transaction.Rewrite &&
    [PolicyStatusMaster.Submission].includes(summary.PolicyStatus) &&
    ![TransactionStatusMaster.RATED, TransactionStatusMaster.COMMITTED, ''].includes(summary.Transaction.Status)
  ) {
    _showPremium = false;
  }
  if (
    [
      PolicyStatusMaster.SubmissionDeclined,
      // PolicyStatusMaster.CancellationInitiated,
      // PolicyStatusMaster.ReInstatementInitiated,
      PolicyStatusMaster.PolicyInForceCancellationRequestPendingApproval,
    ].includes(summary.PolicyStatus)
  ) {
    _showPremium = false;
  }
  if ([commonKeys.RoleAgent].includes(loggedInUserDetails?.decodedJWT?.role)) {
    if (
      [
        PolicyStatusMaster.ReferralAwaitingUWReview,
        PolicyStatusMaster.QuoteIndication,
        PolicyStatusMaster.Submission,
        PolicyStatusMaster.SubmissionDeclined,
        PolicyStatusMaster.SubmissionDeclinedByUW,
      ].includes(summary.PolicyStatus) &&
      summary.Rules.Action !== 'Allow'
    ) {
      _showPremium = false;
    }
  }
  if (
    [PolicyStatusMaster.EndorsementRequestAwaitingUWApproval, PolicyStatusMaster.EndorsementRequestOnHold].includes(
      versionPolicy.PolicyStatus
    )
  ) {
    _showPremium = false;
  }
  //REVIEW AFTER ENDORSEMENT IS COMPLETED
  if (summary?.RatingErrors?.length > 0) {
    _showPremium = false;
  }

  // if (!summary.Attributes.IsCoverageSaved) {
  //   _showPremium = false;
  // }
  return _showPremium;
};

export const calculateEffectiveDate = (date) => {
  return addDateFormatting('', date);
};

export const compareDates = (dateStr1, dateStr2) => {
  const date1 = new Date(dateStr1);
  const date2 = new Date(dateStr2);

  if (date1 < date2) {
    return -1;
  } else if (date1 > date2) {
    return 1;
  } else {
    return 0;
  }
};

export const showHideDownloadRateHelper = async (summary, versionPolicy, loggedInUserDetails) => {
  let _showDownloadRate = true;
  if ([PolicyStatusMaster.SubmissionDeclined].includes(summary.PolicyStatus)) {
    _showDownloadRate = false;
  } else if ([commonKeys.RoleAgent].includes(loggedInUserDetails?.decodedJWT?.role)) {
    _showDownloadRate = false;
  } else if (!summary.Attributes.IsCoverageSaved) {
    _showDownloadRate = false;
  } else if (summary.Transaction.Number > 0) {
    _showDownloadRate = false;
  }
  if (
    [
      PolicyStatusMaster.EndorsementInitiated,
      PolicyStatusMaster.EndorsementRequestAwaitingUWApproval,
      PolicyStatusMaster.EndorsementRequestOnHold,
      RenewalsPolicyStatusMaster.RenewalEndorsementInitiated,
      RenewalsPolicyStatusMaster.RenewalEndorsementRequestAwaitingUWApproval,
    ].includes(versionPolicy.PolicyStatus)
  ) {
    _showDownloadRate = false;
  }

  return _showDownloadRate;
};

export const showStatusHelper = (summary, versionPolicy) => {
  let status = summary.PolicyStatus;
  let remark = summary?.PolicyStatusRemarks ? summary?.PolicyStatusRemarks : '';
  if (
    [
      PolicyStatusMaster.EndorsementInitiated,
      PolicyStatusMaster.EndorsementRequestAwaitingUWApproval,
      PolicyStatusMaster.EndorsementRequestOnHold,
      RenewalsPolicyStatusMaster.RenewalEndorsementInitiated,
      RenewalsPolicyStatusMaster.RenewalEndorsementRequestAwaitingUWApproval,
    ].includes(versionPolicy.PolicyStatus)
  ) {
    status = versionPolicy.PolicyStatus;
    remark = versionPolicy?.PolicyStatusRemarks ? versionPolicy?.PolicyStatusRemarks : '';
  }
  return { status, remark };
};

export const downloadeRateSheet = async (summary) => {
  const templateName = `${
    process.env.NEXT_PUBLIC_CLIENT
  }/templates/${getCurrentLine()}/${getCurrentLob()}/common/RateSheets/TX.html`;
  NProgress.start();
  const printresponse = await triggerNotificationShared(
    commonKeys.ActionDownloadRatesheet,
    commonKeys.NotificationFormatPDF,
    templateName,
    summary,
    false,
    {},
    false
  );
  const url = window.URL.createObjectURL(printresponse);
  var dlnk = document.getElementById('ratedownload');
  dlnk.href = url;
  dlnk.setAttribute('download', `${summary.QuoteNumber}_Rate_Sheet.pdf`);
  dlnk.click();
  NProgress.done();
};

export const getForms = async (summary) => {
  let forms = [];
  if (summary.Forms.length === 0) {
    const formList = await fetchFormFactory(summary);
    const defaultForms = formList?.filter((x) => x.IsMandatory === true || x.IsChecked === true);
    defaultForms?.forEach((form) => {
      forms.push({
        Status: '',
        FormName: form.formName,
        FormDesc: form.formDesc,
        Sequence: form.sequence,
        FormType: form.formType,
        Template: form.template,
        IsMandatory: form.IsMandatory,
        IsChecked: form.IsChecked,
        AcordCode: form.AcordCode,
        File: '',
        Dmspath: '',
      });
    });
  } else {
    forms = summary.Forms;
  }
  return forms;
};

// Lob param to have lob specific checks
export const isPolicyViewMode = () => getStoreState(storeKeys.ApplicationReducer)?.ActionMode === 'View';

export const checkActionDisplay = (button, role, status) => {
  if (isPolicyViewMode()) {
    return false;
  }
  const getRole = getStoreState(storeKeys.DataReducer).roleAuthorization;
  const versionPolicy = getStoreState(storeKeys.VersionReducer);
  if (
    [PolicyStatusMaster.EndorsementRequestOnHold, PolicyStatusMaster.EndorsementRequestAwaitingUWApproval].includes(
      versionPolicy.PolicyStatus
    )
  ) {
    status = versionPolicy.PolicyStatus;
  }
  try {
    if (getRole[role]?.[status]) {
      if (getRole[role]?.[status].includes(button)) {
        return true;
      }
    } else {
      return false;
    }
  } catch (err) {
    console.error(err);
  }
};

export const getUserList = (agents) => {
  const newArray = [];
  for (const item of agents) {
    const obj = {};
    obj.name = item?.Name;
    obj.userId = item?.Code;
    obj.email = item?.Details?.Contact?.EmailId;
    newArray.push(obj);
  }
  return newArray;
};

export const replacePlaceholderWithObject = (data, replaceData) => {
  let dataStr = JSON.stringify(data);

  replaceData.forEach((item) => {
    dataStr = dataStr.replaceAll(item.key, JSON.stringify(item.value));
  });
  return JSON.parse(dataStr);
};

export const formattedStringDate = (inputDate) => {
  if (inputDate && inputDate.length > 0) {
    const finalDate = moment(inputDate).format('MM-DD-YYYY');

    return finalDate;
  } else {
    return null;
  }
};

export const getModelSchema = (routeKeys, replaceData) => {
  const lobSpecificData = getStoreState(storeKeys.ApplicationReducer).selectedBusinessLine;
  const { line, lob, state, carrier, version } = lobSpecificData;
  const schemas = getStoreState(storeKeys.SchemaReducer) || {};
  const flowKey = flowKeys.Modals.toLowerCase();
  const currentPageSchema =
    schemas[line]?.[lob]?.[state]?.[carrier]?.[version]?.[flowKey]?.find((s) => s.PageName === routeKeys)?.Blob ?? [];

  if (replaceData) {
    return replacePlaceholderWithObject(currentPageSchema, replaceData);
  }
  return currentPageSchema;
};

export const getUISchema = async (
  key = 'UISchema',
  flowKeys,
  routeKeys,
  policyData,
  index = -1,
  role = 'UW',
  extraparams = {}
) => {
  const schemaData = await loadDataFromStorage(key, flowKeys.toLowerCase(), routeKeys, index);
  const schema =
    key === 'UISchema' ? AddDefaultValues(routeKeys, schemaData, policyData, role, extraparams) : schemaData;
  return schema;
};

export const statusOptions = (PolicyStatusMaster) => {
  var optionArray = [];
  PolicyStatusMaster = AccountHubPolicyStatusMaster || PolicyStatusMaster;
  Object.entries(PolicyStatusMaster).forEach(([KEY, VALUE]) => {
    if (VALUE !== null) {
      var option = {
        key: KEY,
        label: VALUE,
        value: VALUE,
      };
      optionArray.push(option);
    }
  });
  optionArray.sort((a, b) => (a.label > b.label ? 1 : -1));
  optionArray.unshift({
    key: 'SELECT',
    label: 'All Status',
    value: 'All Status',
  });
  return optionArray;
};

export const staticOptions = (staticItems, key) => {
  var optionArray = [];
  if (key === 'AllowedStates' || key === 'LOBList') {
    const selected = staticItems[`${key}`];
    Object.entries(selected).forEach(([KEY, VALUE]) => {
      var option = {
        key: KEY,
        label: VALUE,
        value: VALUE,
      };
      optionArray.push(option);
    });
  }
  return optionArray;
};

export const getLobFromSchemaData = (schemaData) => {
  try {
    return schemaData[0].lob;
  } catch (err) {
    console.error(err);
    return 'personal/homeowners'; // TODO: temporary safe default value
  }
};

export const downloadForms = async (formsFactory, summary, isDraft = true, transType, fileName = '') => {
  NProgress.start();
  const tempSummary = addRequiredForms(
    formsFactory['Required Forms'], // Add this if optional forms required
    formsFactory['Optional Forms'],
    summary
  );

  const formsResponse = await generateDocument(
    tempSummary,
    isDraft,
    false,
    tempSummary.forms,
    { 'Content-Type': 'application/json' },
    'blob',
    transType,
    `false&transformationKey=${process.env.NEXT_PUBLIC_FORMS_TRANFORMATION_KEY}`,
    null,
    false
  );
  if (formsResponse) {
    var blob = new Blob([formsResponse], { type: 'application/pdf' });
    var link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    var fname = isDraft ? `${summary.QuoteNumber}_Draft_Forms` : fileName;
    link.download = fname;
    link.click();
  }
  NProgress.done();
};

export const addRequiredForms = (mandatoryForms, optionalForms, policy) => {
  try {
    const tempSummary = JSON.parse(JSON.stringify(policy));
    tempSummary.Forms = [];
    mandatoryForms
      ?.filter((x) => x.IsMandatory === true || x.IsChecked === true)
      ?.forEach((form) => {
        tempSummary.Forms.push({
          Status: '',
          FormName: form.formName,
          FormDesc: form.formDesc,
          Sequence: form.sequence,
          FormType: form.formType,
          Template: form.template,
          IsMandatory: form.IsMandatory,
          IsChecked: form.IsChecked,
          AcordCode: form.AcordCode,
          File: '',
          Dmspath: '',
          BlobLocation: form.BlobLocation,
        });
      });
    optionalForms
      ?.filter((x) => x.IsMandatory === true || x.IsChecked === true)
      ?.forEach((form) => {
        tempSummary.Forms.push({
          Status: '',
          FormName: form.formName,
          FormDesc: form.formDesc,
          Sequence: form.sequence,
          FormType: form.formType,
          Template: form.template,
          IsMandatory: form.IsMandatory,
          IsChecked: form.IsChecked,
          AcordCode: form.AcordCode,
          File: '',
          Dmspath: '',
          BlobLocation: form.BlobLocation,
        });
      });
    return tempSummary;
  } catch (err) {
    console.error(err);
    throw err;
  }
};

export const validEmailCheck = (email) => {
  // Regular expression for basic email validation
  const emailRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z]{2,})+$/;
  return !emailRegex.test(email);
};

export const hasFeatureSelector = (state, key) => {
  const tableList = getStoreState(storeKeys.DataReducer)?.roleAuthorization?.Integrations;

  return state?.masterReducer?.[tableList?.[key]?.tableName]?.find(
    (item) => item[tableList?.[key]?.keyName] === tableList?.[key]?.value
  )?.Enabled;
};

export const isDDMIntegrationActive = (key = 'DDM') => {
  try {
    const tableList = getStoreState(storeKeys.DataReducer)?.roleAuthorization?.Integrations;
    const masterReducer = getStoreState(storeKeys.MasterReducer)?.Integrations;
    const isActive = masterReducer?.find((item) => item.IntegrationName === tableList?.[key]?.value).Enabled;
    return isActive;
  } catch (error) {
    console.error(error);
    return false;
  }
};

/**Method to transform the list of policies into dashboard specific objects
 * @param {[policies]} resp - list of polcies
 * @param {boolean} IsRenew - flag to tag whether the process records is for renewals or account hub
 * @returns {[transformedPolicies]} - list of transformed policies
 */
export const ProcessAccountHubData = (resp, IsRenew = false) => {
  const lob = currentLineLob();
  try {
    if (resp?.length > 0) {
      const data = resp.map((m) => masterModalHelper(LOAD_ACCOUNTHUB_DATA, lob, [m, IsRenew]));
      data.sort((a, b) => {
        if (new Date(a.LastUpdatedDate) > new Date(b.LastUpdatedDate)) {
          return -1;
        } else {
          return 1;
        }
      });

      return data;
    } else {
      return [];
    }
  } catch (error) {
    logAPIErrorData(error, { resp, IsRenew }, consoleLogs.Utilities.Apollo.Operations.ProcessAccountHubData);
  }
};

const validateJSONata = async (expression, data) => {
  expression = jsonata(expression);
  const result = await expression.evaluate(data);
  return result;
};

const getValueFromStatetByPath = (path, policyData) => {
  return path?.split('.').reduce(
    (o, key) =>
      o && o[key]
        ? // ?.toString()
          o[key]
        : null,
    policyData
  );
};

export const validate = async (validator, policyData) => {
  const errors = {};
  const validators = validator;
  let gotError = false;

  for (const component of validators) {
    const fieldValue = getValueFromStatetByPath(component.key);

    for (const condition of component.validations) {
      let r;
      if (condition.expression) {
        r = await validateJSONata(condition.expression, policyData);
      } else {
        r = condition.validator(fieldValue, policyData);
      }

      if (!r && !gotError) {
        if (errors[component.key] === undefined) {
          errors[component.key] = [];
        }
        errors[component.key].push(condition.message);
        gotError = true;
      }
    }
  }
  return errors;
};

const gqlEndPoint = process.env.NEXT_PUBLIC_GQL_END_POINT;

const defaultInputClause = {
  input: {
    clause: [{ src: '1', def: '1', exp: '=', operator: '' }],
    containerName: 'policy',
    LIMIT: 100,
    client: getStoreState(storeKeys.ApplicationReducer).selectedBusinessLine?.client || process.env.NEXT_PUBLIC_CLIENT,
    line: getCurrentLine() || process.env.NEXT_PUBLIC_LINE,
    lob: getCurrentLob() || process.env.NEXT_PUBLIC_LINE_OF_BUSINESS,
  },
};

const dbKeys = {
  policystatus: 'c.PolicyStatus',
  agentid: 'c.Agent.Code',
  agentname: 'c.Agent.Name',
  underwriterid: 'c.UnderWriter.Name',
  fromdate: 'c.EffectiveDate',
  todate: 'c.EffectiveDate',
  transactiondate: 'c.Transaction.Date',
  quoteNumber: 'c.QuoteNumber',
  policynumber: 'c.PolicyNumber',
  insuredname: 'c.InsuredAccount.DisplayName',
  propertyaddress: 'c.Risks.Properties.0.Address.UnFormattedAddress',
  state: 'c.Attributes.State',
  lob: 'c.Attributes.Lob',
};

const getExpression = (key) => {
  if (key === 'fromdate') {
    return '>=';
  }
  if (key === 'todate') {
    return '<=';
  }
  if (['agentid', 'underwriterid', 'lob', 'insuredname', 'state', 'policynumber', 'quoteNumber'].includes(key)) {
    return 'LIKE';
  }
  return '=';
};

const buildClause = (key, value) => {
  const expression = getExpression(key);
  const clause = {
    src: dbKeys[key],
    def: `'${value}'`,
    exp: expression,
    operator: 'AND',
  };

  if (['agentid', 'underwriterid', 'lob', 'insuredname', 'state', 'policynumber', 'quoteNumber'].includes(key)) {
    clause.src = `UPPER(${dbKeys[key]})`;
    clause.def = `'%${value.toUpperCase()}%'`;
  }

  return clause;
};

const addInitialClauses = (input) => {
  input.input.clause.push({
    src: '(c.PolicyStatus',
    def: "'Renewal-Offered' OR c.PolicyStatus='Renewal Offer Rejected By UW' OR c.PolicyStatus='Renewal Offer Rejected By Agent' OR c.PolicyStatus='Renewal Submission' OR c.PolicyStatus='Renewal Signature Pending' OR c.PolicyStatus='Renewal-Offered Expired' OR c.PolicyStatus='Renewal Expired' OR c.PolicyStatus='Renewed-Endorsement Pending Approval' OR c.PolicyStatus='Renewed-Endorsement Request on Hold')",
    exp: '!=',
    operator: 'AND',
  });

  input.input.clause.push({
    src: 'c.Attributes.Client',
    def: `'${process.env.NEXT_PUBLIC_CLIENT}'`,
    exp: '=',
    operator: 'AND',
  });

  input.input.clause.push({
    src: 'c.Attributes.Lob',
    def: `'${getCurrentLob()}'`, // Assuming getCurrentLob() returns the current lob
    exp: '=',
    operator: 'AND',
  });

  if (getCurrentLob() === 'PA') {
    input.input.clause.push({
      src: '(c.Attributes.AppSource',
      def: "'POS' OR c.Attributes.AppSource='SIS' OR (c.Attributes.AppSource='TURBORATER' AND c.Attributes.IsBridge=true))",
      exp: '=',
      operator: 'AND',
    });
  }

  return input;
};

export const getInputClause = (initialLoad, accounthubModel) => {
  const selectedBusinessLine = getStoreState(storeKeys.ApplicationReducer).selectedBusinessLine;
  const { line, lob, client } = selectedBusinessLine ? selectedBusinessLine : {};
  defaultInputClause.input.client = client;
  defaultInputClause.input.line = line;
  defaultInputClause.input.lob = lob;

  const input = structuredClone(defaultInputClause);
  if (!initialLoad) {
    Object.keys(accounthubModel).forEach((key) => {
      if (accounthubModel[key]?.length > 0) {
        input.input.clause.push(buildClause(key, accounthubModel[key]));
      }
    });
  }

  addInitialClauses(input);
  return input;
};

export const LoadAccountHub = async (initialLoad, accounthubModel, ProcessAccountHubDataFunc, input) => {
  try {
    const queries = getStoreState(storeKeys.QueriesReducer);

    const resp = await executeQuery(getApolloClient(gqlEndPoint), GRAPHQL_QUERIES(queries, 'GETACCOUNTHUB', []), input);
    let data = [];
    if (resp) {
      data = await ProcessAccountHubDataFunc(resp.data[apolloKeys.GetByFilter]);
    }
    return data !== null || data !== undefined ? data : null;
  } catch (error) {
    console.error(consoleLogs.Utilities.Apollo.Operations.LoadAccountHub, error);
    logAPIErrorData(error, { initialLoad, accounthubModel }, consoleLogs.Utilities.Apollo.Operations.LoadAccountHub);
  }
};

export const resetConditionalData = async (model) => {
  if (!checkBoolean(model.Underwriting.AnyResidenceEmployees)) {
    model.Underwriting.NoOfFullTimeEmployees = '';
    model.Underwriting.NoOfPartTimeEmployees = '';
    return model;
  }
  if (!checkBoolean(model.Underwriting.IsAnyOtherInsuranceWithCompany)) {
    model.Underwriting.ListPolicyNumber = '';
    return model;
  }

  if (!checkBoolean(model.Underwriting.HadForeclosureRepossessionOrBankruptcy)) {
    model.Underwriting.ReasonForForeclosureRepossessionOrBankruptcy = '';
    model.Underwriting.StatusForForeclosureRepossessionOrBankruptcy = '1';
    return model;
  }
  if (model.Underwriting.StatusForForeclosureRepossessionOrBankruptcy === '1') {
    model.Underwriting.DateClosedStatusForForeclosureRepossessionOrBankruptcy = '';
    return model;
  }
  if (!checkBoolean(model.Underwriting.IsExoticAnimalOrPet)) {
    model.Underwriting.AnimalOrPetBreed = '';
    model.Underwriting.IsAnimalWithBiteHistory = 'false';
    return model;
  }

  if (!checkBoolean(model.Underwriting.IsAnimalWithBiteHistory)) {
    model.Underwriting.AddTypeOfAnimalBox = '';
    return model;
  }
  if (!checkBoolean(model.Underwriting.IsPropertyMoreThanFiveAcres)) {
    model.Underwriting.NoOfAcres = '';
    model.Underwriting.DescribeLandUse = '';
    return model;
  }
  if (!checkBoolean(model.Underwriting.OtherStructureOnPremise)) {
    model.Underwriting.DescribeStructureOnPremise = '';
    return model;
  }

  if (!checkBoolean(model.Underwriting.IsUnderRenovationOrReconstruction)) {
    model.Underwriting.ContractorName = '';
    model.Underwriting.CompletionDate = '';
    model.Underwriting.CompletedValue = '';
    return model;
  }
  if (!checkBoolean(model.Underwriting.IsAnySwimingPool)) {
    model.Underwriting.IsSwimingPoolEnclosed = 'false';
    model.Underwriting.IsAnyDivingBoardsPresent = 'false';
    model.Underwriting.IsAnySlidesPresent = 'false';
    return model;
  }
  if (!checkBoolean(model.Underwriting.IsThePropertyCurrentlyInsured)) {
    model.Underwriting.PriorInsuranceCompany = '';
    model.Underwriting.PriorInsurancePolicyNumber = '';
    model.Underwriting.PriorInsuranceExpirationDate = '';
    return model;
  }
  if (model.PriorInsurances.LapsesInCoverages === '0') {
    model.PriorInsurances.ReasonLapsesInCoverages = '';
    return model;
  }
};

export const combineAddress = async (additionalParties) => {
  return additionalParties?.map((ap) => {
    if (ap.Address) {
      ap.Address.UnFormattedAddress =
        ap.Address?.AddressLine1 + ', ' + ap.Address?.City + ', ' + ap.Address?.State + ' ' + ap.Address?.Zip;
    }
  });
};

//#endregion BASEPAGE FUNCTIONS

export const currentLineLob = () => {
  const selectedBusinessLine = getStoreState(storeKeys.ApplicationReducer).selectedBusinessLine;
  return `${selectedBusinessLine?.line}/${selectedBusinessLine?.lineOfBusiness}`.toLowerCase() || '';
};

export const generateDocumentHelper = async (model, documentType, folderName) => {
  const formList = [];

  try {
    const { staticItems } = require(`ui/data/${currentLineLob()}/constants/static.js`);
    const dmsProperties = getDMSProperties(model, documentType, '', folderName);
    let forms;
    if (model.Forms.length > 0) {
      forms = model.Forms;
    } else {
      forms = await fetchFormFactory(model, documentType, staticItems);
    }
    forms.map((form) => {
      if (form.IsChecked === true) {
        const form_name = form?.formName ?? form?.FormName;
        formList.push(form_name);
      }
    });
    await generateDocument(
      model,
      process.env.NEXT_PUBLIC_DEFAULT_FORMS_ISDRAFT === 'true' ? true : false,
      false,
      formList,
      { 'Content-Type': 'application/json' },
      'blob',
      null,
      false,
      dmsProperties,
      true
    );
  } catch (e) {
    console.error(e, 'error in generateDocument');
  }
};

export const addNumberInOrder = (Milestones, number) => {
  // Check if the number is already present in the array
  if (!Milestones.includes(number)) {
    // Add the number to the array
    Milestones.push(number);
    // Sort the array in ascending order
    Milestones.sort((a, b) => a - b);
  }
  return Milestones;
};

// export const setCurrentPolicy = (policy) => {
export const setCurrentPolicy = () => {
  const policy = getStoreState(storeKeys.PolicyReducer);
  const masterReducer = getStoreState(storeKeys.MasterReducer);
  masterReducer['prevPolicy'] = policy;
  setStoreState(storeKeys.MasterReducer, masterReducer);
};

export function camelToSnakeUppercase(camelCase) {
  return camelCase
    .replace(/([A-Z])/g, '_$1')
    .toUpperCase()
    .replace(/^_/, '');
}

export function extractFragments(data) {
  const regex = /\.\.\.\w+/g; // Regular expression to match words starting with "..."
  const matches = data?.match(regex); // Find all matches
  return matches ? matches?.map((match) => camelToSnakeUppercase(match?.slice(3))) : []; // Convert to snake case uppercase
}

export const effectiveDateFormatter = (cell, row) => {
  return `${moment(row.EffectiveDate).format('L')}`;
};

export const transactionEffectiveDateFormatter = (cell, row) => {
  return `${moment(row.TransactionDate).format('L')}`;
};

export const UnStringifyData = (model, pageName, _indx = 0) => {
  switch (pageName) {
    case routeKeys.EndorsementPolicyHolder:
    case routeKeys.ApplicationPolicyHolder:
      if (model.NonFunctional.Milestones.includes(1)) {
        model.InsuredAccount.BusinessInfo.DOTNumber = parseInt(model.InsuredAccount.BusinessInfo.DOTNumber);
        model.InsuredAccount.BusinessInfo.YearsInBusiness = parseInt(model.InsuredAccount.BusinessInfo.YearsInBusiness);
        // model.Attributes.State = model.InsuredAccount.BusinessInfo.Locations[0]?.Address?.State;
        // model.Attributes.Product = model.Attributes.Client + model.Attributes.Carrier + model.Attributes.Lob + model.Attributes.State;
        model.Attributes.Product =
          model.Attributes.Carrier + model.Attributes.Coverholder + model.Attributes.Lob + model.Attributes.State;
        // model.Attributes.Product = "CAACMAK"        ;
        if (model.InsuredAccount.BusinessInfo.Commodities.length) {
          model.InsuredAccount.BusinessInfo.Commodities.map((c) => {
            if (c.HauledPercentage === commonKeys.StringZero) {
              c.HauledPercentage = 0;
            }
            if (c.MaxValue === commonKeys.StringZero) {
              c.MaxValue = 0;
            }
            if (c.AvgValue === commonKeys.StringZero) {
              c.AvgValue = 0;
            }
          });
        }
      }
      break;

    case routeKeys.EndorsementNewVenture:
    case routeKeys.ApplicationNewVenture:
      if (model.NonFunctional.Milestones.includes(2)) {
        model.Underwriting.NewVentureQueries.CommercialClassALicenseYears = parseInt(
          model.Underwriting.NewVentureQueries.CommercialClassALicenseYears
        );
      }
      break;

    case routeKeys.EndorsementDriverInfo:
    case routeKeys.ApplicationDriverInfo:
      if (model.NonFunctional.Milestones.includes(4)) {
        model.Risks.Drivers.map((driver) => {
          driver.NewVenture.CDLAExperience = parseInt(driver?.NewVenture?.CDLAExperience);
          driver.NewVenture.IndustryExperience = parseInt(driver.NewVenture.IndustryExperience);
          driver.NewVenture.TransportingExperience = parseInt(driver.NewVenture.TransportingExperience);
        });
      }
      break;

    case routeKeys.EndorsementOperationDetails:
    case routeKeys.ApplicationOperationDetails:
      if (model.NonFunctional.Milestones.includes(5)) {
        model.InsuredAccount.BusinessInfo.LossHistory.forEach((element) => {
          element.NumberOfLosses = parseInt(element.NumberOfLosses);
          element.Reserves = parseInt(element.Reserves);
          element.Paid = parseInt(element.Paid);
          element.TotalIncurred = parseInt(element.TotalIncurred);
          element.AnnualPremium = parseFloat(element.AnnualPremium);
        });
      }
      break;

    case routeKeys.EndorsementCoverageInfo:
    case routeKeys.ApplicationCoverageInfo:
      if (model.NonFunctional.Milestones.includes(6)) {
        model.PolicyCoverages.Coverages.forEach((element) => (element.Deductible = parseInt(element.Deductible)));
        model.RatingAttribute.HiredAutoCount = parseInt(model.RatingAttribute.HiredAutoCount) || 0;
        model.RatingAttribute.NonOwnedAutoCount = parseInt(model.RatingAttribute.NonOwnedAutoCount) || 0;
        model.RatingAttribute.WaiverOfSubrogation = parseInt(model.RatingAttribute.WaiverOfSubrogation) || 0;
        model.RatingAttribute.TrailersCount = parseInt(model.RatingAttribute.TrailersCount) || 0;
        model.RatingAttribute.RefrigerationDeductible = parseInt(model.RatingAttribute.RefrigerationDeductible) || 0;
        model.RatingAttribute.DryVanFlatbedDeductible = parseInt(model.RatingAttribute.DryVanFlatbedDeductible) || 0;
        if (model.PolicyCoverages.Coverages[23].Limit === commonKeys.Others) {
          model.PolicyCoverages.Coverages[23].Limit = model.PolicyCoverages.Coverages[23].LimitAmount.toString();
          model.PolicyCoverages.Coverages[23].LimitAmount = parseInt(model.PolicyCoverages.Coverages[23].LimitAmount);
        }
      }
      break;

    case routeKeys.EndorsementGeneralLiabilities:
    case routeKeys.ApplicationGeneralLiabilities:
    case routeKeys.ApplicationQuoteIndication:
      if (model.NonFunctional.Milestones.includes(8)) {
        model.InsuredAccount.BusinessInfo.Operations.History.map((h) => {
          if (h?.GrossReceipts) {
            h.GrossReceipts = parseInt(h?.GrossReceipts);
          }
          if (h?.PowerUnits) {
            h.PowerUnits = parseInt(h?.PowerUnits);
          }
          if (h?.TotalMiles) {
            h.TotalMiles = parseInt(h?.TotalMiles);
          }
        });
        model.InsuredAccount.BusinessInfo.Operations.DrivingHiring.ExperienceYear = parseInt(
          model.InsuredAccount.BusinessInfo.Operations.DrivingHiring.ExperienceYear
        );
      }
      break;

    case routeKeys.Root:
      //BusinessInfo
      model.InsuredAccount.BusinessInfo.DOTNumber = parseInt(model.InsuredAccount.BusinessInfo.DOTNumber);
      model.InsuredAccount.BusinessInfo.YearsInBusiness = parseInt(model.InsuredAccount.BusinessInfo.YearsInBusiness);

      model.InsuredAccount.BusinessInfo.OperationDetails.TravellingHowOften = parseInt(
        model.InsuredAccount.BusinessInfo.OperationDetails.TravellingHowOften
      );
      // model.Attributes.State = model.InsuredAccount.BusinessInfo.Locations[0]?.Address?.State;
      // model.Attributes.Product = model.Attributes.Client + model.Attributes.Carrier + model.Attributes.Lob + model.Attributes.State;
      model.Attributes.Product =
        model.Attributes.Carrier + model.Attributes.Coverholder + model.Attributes.Lob + model.Attributes.State;
      // model.Attributes.Product = "CA AC M AK";
      if (model.InsuredAccount.BusinessInfo.Commodities.length) {
        model.InsuredAccount.BusinessInfo.Commodities.map((c) => {
          if (c.HauledPercentage === commonKeys.StringZero) {
            c.HauledPercentage = 0;
          }
          if (c.MaxValue === commonKeys.StringZero) {
            c.MaxValue = 0;
          }
          if (c.AvgValue === commonKeys.StringZero) {
            c.AvgValue = 0;
          }
        });
      }

      //New Venture
      model.Underwriting.NewVentureQueries.CommercialClassALicenseYears = parseInt(
        model.Underwriting.NewVentureQueries.CommercialClassALicenseYears
      );

      //DriverInfo
      model.Risks?.Drivers?.map((driver) => {
        if (driver?.NewVenture) {
          driver.NewVenture.CDLAExperience = parseInt(driver?.NewVenture?.CDLAExperience);
          driver.NewVenture.IndustryExperience = parseInt(driver.NewVenture.IndustryExperience);
          driver.NewVenture.TransportingExperience = parseInt(driver.NewVenture.TransportingExperience);
        }
      });

      //Operations
      model.InsuredAccount.BusinessInfo.LossHistory.forEach((element) => {
        element.NumberOfLosses = parseInt(element.NumberOfLosses);
        element.Reserves = parseInt(element.Reserves);
        element.Paid = parseInt(element.Paid);
        element.TotalIncurred = parseInt(element.TotalIncurred);
        element.AnnualPremium = parseFloat(element.AnnualPremium);
      });

      // CoverageInfo
      model.PolicyCoverages.Coverages.forEach((element) => (element.Deductible = parseInt(element.Deductible)));
      model.RatingAttribute.HiredAutoCount = parseInt(model.RatingAttribute.HiredAutoCount) || 0;
      model.RatingAttribute.NonOwnedAutoCount = parseInt(model.RatingAttribute.NonOwnedAutoCount) || 0;
      model.RatingAttribute.WaiverOfSubrogation = parseInt(model.RatingAttribute.WaiverOfSubrogation) || 0;
      model.RatingAttribute.TrailersCount = parseInt(model.RatingAttribute.TrailersCount) || 0;
      model.RatingAttribute.RefrigerationDeductible = parseInt(model.RatingAttribute.RefrigerationDeductible) || 0;
      model.RatingAttribute.DryVanFlatbedDeductible = parseInt(model.RatingAttribute.DryVanFlatbedDeductible) || 0;
      if (model.PolicyCoverages.Coverages[23].Limit === commonKeys.Others) {
        model.PolicyCoverages.Coverages[23].Limit = model.PolicyCoverages.Coverages[23].LimitAmount.toString();
        model.PolicyCoverages.Coverages[23].LimitAmount = parseInt(model.PolicyCoverages.Coverages[23].LimitAmount);
      }

      //GeneralLiabilities
      model.InsuredAccount.BusinessInfo.Operations.History.map((h) => {
        if (h?.GrossReceipts) {
          h.GrossReceipts = parseInt(h?.GrossReceipts);
        }
        if (h?.PowerUnits) {
          h.PowerUnits = parseInt(h?.PowerUnits);
        }
        if (h?.TotalMiles) {
          h.TotalMiles = parseInt(h?.TotalMiles);
        }
      });

      model.InsuredAccount.BusinessInfo.Operations.DrivingHiring.ExperienceYear = parseInt(
        model.InsuredAccount.BusinessInfo.Operations.DrivingHiring.ExperienceYear
      );
      break;

    default:
      break;
  }
  return model;
};

export const checkLobStatus = async (model, isEndorsement, passivePolicies) => {
  let errorLobStatus = false;
  let oneLobRequired = false;
  let totalPremium = 0;
  let errorMsg = commonKeys.EmptyString;

  //Check for Rating Errored LOB
  const _passivePolicies = passivePolicies
    ? passivePolicies
    : await loadPassivePolicies(model.QuoteNumber, model.QuoteVersion);
  _passivePolicies.map((pol) => {
    if (
      pol?.RatingErrors?.length > 0 &&
      ![
        PolicyStatusMaster.LOBNotOfferedByAgent,
        PolicyStatusMaster.LOBNotOfferedByUW,
        PolicyStatusMaster.SubmissionClosed,
      ].includes(pol.PolicyStatus)
    ) {
      errorLobStatus = true;
    }
    if (
      ![
        PolicyStatusMaster.LOBNotOfferedByAgent,
        PolicyStatusMaster.LOBNotOfferedByUW,
        PolicyStatusMaster.SubmissionClosed,
      ].includes(pol.PolicyStatus)
    ) {
      totalPremium = totalPremium + pol.TotalPremium.AnnualPremiumWithFeesAndTaxes;
    }
  });

  oneLobRequired =
    _passivePolicies.filter((p) =>
      [
        PolicyStatusMaster.LOBNotOfferedByAgent,
        PolicyStatusMaster.LOBNotOfferedByUW,
        PolicyStatusMaster.SubmissionClosed,
      ].includes(p.PolicyStatus)
    ).length === 4;

  if (!isEndorsement) {
    if (oneLobRequired) {
      errorMsg = alertMsgs.FormalQuote.NeedAtleast1LOBs;
    } else if (errorLobStatus) {
      errorMsg = alertMsgs.FormalQuote.FailedLOB;
    } else if (parseFloat(totalPremium) > parseFloat(process.env.NEXT_PUBLIC_DEFAULT_IPFS_LIMIT)) {
      errorMsg = alertMsgs.FormalQuote.IPFSCheck;
    }
  }
  return { errorMsg };
};

export const lobImageSummaryMap = {
  HO3: 'home-1.svg',
  FLD: 'flood.svg',
  PA: 'PA.png',
};

export const phoneNumberFormat = (value) => {
  const cleaned = ('' + value).replace(/\D/g, '');
  const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);

  if (match) {
    return match[1] + '-' + match[2] + '-' + match[3];
  }
  return null;
};

export const CommaSeparatedNumber = (num) => {
  let _formattedResp = '';
  try {
    if (typeof num === 'string' && num.length > 0) {
      num = num.replaceAll(',', '');
    }
    if (parseInt(num) === 0 || (num && !isNaN(num) && isFinite(num))) {
      num = num.toString();
      return (_formattedResp = parseFloat(num)
        .toFixed(0)
        .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,'));
    } else {
      return '0';
    }
  } catch (error) {
    console.error('Utilities.Shared.Helpers.CurrencyFormat ', error);
    throw Error();
  }
};

export const currencyFormatWithRange = (num) => {
  const amt = num?.toString();
  const splitAmount = amt?.includes('-') ? amt?.split('-') : [];
  const amount = splitAmount?.map((a) =>
    a.toString().includes(',')
      ? '$' + a + '.00'
      : '$' +
        parseFloat(a)
          .toFixed(0)
          .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
  );

  return amount.join('-');
};

export const getDeclineStatus = (transactionType) => {
  try {
    switch (transactionType) {
      case TransactionTypeMaster.NEW:
      case TransactionTypeMaster.APPLICATION:
      case TransactionTypeMaster.QUOTE:
        return PolicyStatusMaster.SubmissionClosed;
      case TransactionStatusMaster.INPROGRESS:
        return PolicyStatusMaster.BindRequestDeclined;
      case TransactionTypeMaster.RENEWAL:
        return RenewalsPolicyStatusMaster.RenewalSubmissionClosed;
    }
  } catch (error) {
    console.error(consoleLogs.Utilities.Pages.Shared.GetBindStatus, error);
    throw error;
  }
};
export const GetBusinessName = (policy) =>
  policy?.InsuredAccount?.BusinessInfo?.BusinessType === 'Individual'
    ? policy?.InsuredAccount?.BusinessInfo?.FirstName +
      ' ' +
      policy?.InsuredAccount?.BusinessInfo?.MiddleName +
      ' ' +
      policy?.InsuredAccount?.BusinessInfo?.LastName
    : policy?.InsuredAccount?.BusinessInfo?.BusinessName;

export const invokeAdaptiveAPIViaHook = async (model, action, routeKey, callBackPage = '') => {
  const resp = await save(model, action, routeKey, callBackPage);
  return resp;
};

// ... existing code ...
const GetAllByContainerMerged = async (userType = ['getUnderwriters', 'getAgents', 'getAgencies']) => {
  const lob = getCurrentLob();
  const containerMap = {
    getUnderwriters: 'underwriter',
    getAgents: 'agents',
    getAgencies: 'agencies',
  };

  const results = await Promise.all(
    userType.map(async (x) => {
      try {
        const containerName = containerMap[x];
        const users = await getAgentsAgenciesUW(x, lob);
        return { [containerName]: users };
      } catch (error) {
        console.error(`Error fetching data for ${x}:`, error);
        throw error;
      }
    })
  );

  const mergedResults = results.reduce((acc, curr) => ({ ...acc, ...curr }), {});
  setStoreState(storeKeys.MasterReducer, mergedResults);
};
// ... existing code ...
export const loadInitalData = async () => {
  try {
    const lineLob = currentLineLob();
    const { staticItems } = require(`ui/data/${lineLob}/constants/static.js`);
    await fetchQueriesAndFragments();
    await setData({
      routeKeys,
      staticItems,
    });

    await Promise.all([
      loadMastersByContainer(staticItems),
      fetchUISchemaByFlow(flowKeys.Modals.toLowerCase()).catch(() => {
        return [];
      }),
      fetchUISchemaByFlow(flowKeys.AccountHub.toLowerCase()).catch(() => {
        return [];
      }),
      fetchUISchemaByFlow(flowKeys.PolicyServicing.toLowerCase()).catch(() => {
        return [];
      }),
      setPolicy(getInitialState()),
      fetchRoleAuthorization(),
      fetchValidation(),
      fetchActionConfig(),
      setUserRole(),
    ]);
    if (isDDMIntegrationActive()) {
      await fetchUserInformationDetails();
    } else {
      await GetAllByContainerMerged();
    }
  } catch (error) {
    console.error('Error fetching data:', error);
    throw error;
  }
};

export const loadSelectedLineLob = async () => {
  try {
    const url = `${process.env.NEXT_PUBLIC_MASTER_DATA_URL}master?client=${process.env.NEXT_PUBLIC_CLIENT}&table=SelectedLineLob`;
    const resp = await callAPI('GET', url);
    if (resp) {
      setStoreState(storeKeys.MasterReducer, {
        selectedLineLob: resp,
      });
      return resp;
    }
  } catch (error) {
    console.error('Error fetching data:', error);
  }
};

export const validateAdditionalPartiesCount = async (additionalParties) => {
  const maxAddParty = 3;
  if (typeof additionalParties !== 'undefined' && additionalParties.length > maxAddParty) {
    additionalParties.pop();
  }
};
export const getCompareColumnsSchema = (flowKeys, routeKeys) => {
  return loadDataFromStorage('UISchema', flowKeys.toLowerCase(), routeKeys, -1);
};

export const fetchCQuotes = async (policy) => {
  const payload = {
    client: policy.Attributes.Client,
    filters: {
      id: policy.id,
      QuoteNumber: policy.QuoteNumber,
      QuoteVersion: '',
      MasterQuoteNumber: '',
      Carrier: '',
      Lob: '',
      Coverholder: '',
      IsQuoteSelected: false,
    },
  };
  const cquotes = await callAPI('POST', process.env.NEXT_PUBLIC_GET_COMPARATIVE_QUOTE_URL, payload, {
    'Content-Type': 'application/json',
  });
  return cquotes;
};

export const formatDateMMDDYYYYTT = (dateString) => {
  const date = new Date(dateString);

  const month = String(date.getMonth() + 1).padStart(2, '0'); // Month is 0-indexed
  const day = String(date.getDate()).padStart(2, '0');
  const year = date.getFullYear();

  let hours = date.getHours();
  const ampm = hours >= 12 ? 'PM' : 'AM';
  hours = hours % 12;
  hours = hours ? hours : 12; // the hour '0' should be '12'

  const formattedDate = `${month}/${day}/${year} ${String(hours).padStart(2, '0')}:${String(date.getMinutes()).padStart(2, '0')}:${String(date.getSeconds()).padStart(2, '0')} ${ampm}`;

  return formattedDate;
  // console.log(formattedDate); // Output: 02/19/2025 10:44:44 AM
};

export const formatCurrency = (amount = '', placeholder = '') => {
  if (amount === null || amount === '') {
    return placeholder;
  }

  const isNegative = amount < 0;
  const formattedAmount = Math.abs(amount).toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD',
  });

  return isNegative ? `(${formattedAmount})` : formattedAmount;
};

export const getCoverageValue = (model, key) => {
  return model?.Risks.Properties[0].Coverages.find((ele) => ele.Name === key).Value;
};

export const setterForCoverageValue = (model, key, value) => {
  model.Risks.Properties[0].Coverages.find((ele) => ele.Name === key).Value = value;
  return model;
};

export const dateFormatterNew = (date = '', monthFormat = false) => {
  let newFormat = '';
  if (date.includes('/')) {
    return 'Invalid Date';
  }
  if (date.length > 0 && monthFormat) {
    const tempDate = date.split('-');
    newFormat = tempDate[1] + '/' + tempDate[0];
    return newFormat;
  }
  if (date.length > 0) {
    const tempDate = date.split('-');
    newFormat = tempDate[1] + '/' + tempDate[2] + '/' + tempDate[0];
    return newFormat;
  }
  return date;
};

export const EndorsementSummaryActionButtons = (
  policy,
  buttonStatus,
  status,
  role,
  PolicyStatusMaster,
  _isBackdatedEndorsementAllowedForAgent = false
) => {
  if (buttonStatus) {
    return buttonStatus;
  }

  const agentActionButtons = { showExitButton: true };

  if (role === 'Agent') {
    agentActionButtons.showApproveEndorsementButton = false;
    agentActionButtons.showSubmitForApprovalButton = true;
  }

  const userRoles = {
    Agent: [
      {
        policyStatus: PolicyStatusMaster.EndorsementInitiated,
        actionButtons: agentActionButtons,
      },
    ],
    Underwriter: [
      {
        policyStatus: PolicyStatusMaster.EndorsementInitiated,
        actionButtons: {
          showExitButton: true,
          showRejectButton: false,
          showOnHoldButton: false,
          showReviewFormsButton: true,
          showApproveEndorsementButton: false,
        },
      },
      {
        policyStatus: PolicyStatusMaster.EndorsementRequestAwaitingUWApproval,
        actionButtons: {
          showExitButton: true,
          showRejectButton: true,
          showOnHoldButton: false,
          showReviewFormsButton: true,
          showApproveEndorsementButton: false,
        },
      },
      {
        policyStatus: PolicyStatusMaster.EndorsementRequestOnHold,
        actionButtons: {
          showExitButton: true,
          showRejectButton: true,
          showOnHoldButton: false,
          showReviewFormsButton: true,
          showApproveEndorsementButton: false,
        },
      },
    ],
  };

  const roleConfig = userRoles[role]?.find((val) => val.policyStatus === status);
  return roleConfig ? roleConfig.actionButtons : {};
};

const suffixOnNumber = (num = 1) => {
  let suffix = 'th';
  if (num === 0) {
    suffix = '';
  }
  if (num % 10 === 1 && num % 100 !== 11) {
    suffix = 'st';
  }
  if (num % 10 === 2 && num % 100 !== 12) {
    suffix = 'nd';
  }
  if (num % 10 === 3 && num % 100 !== 13) {
    suffix = 'rd';
  }

  return num + suffix;
};

export const DisplayRulesInPolicy = (policy, newBuisness = false) => {
  const numberWithSuffix = suffixOnNumber(policy.Transaction.Number);
  let header = numberWithSuffix + ' ' + policy.Transaction.Type;
  if (newBuisness) {
    header = 'New Buisness';
  }
  policy.Rules.MatchingRules.forEach((ele) => {
    policy.DisplayRules.push({
      Reason: ele.Reason,
      Header: header,
    });
  });
  policy.Rules.MatchingRules = [];
  return policy;
};

export const fetchForms = async (policy, base) => {
  try {
    const productCode = policy.Attributes.Product;
    const transactionType = base.staticItems.FormFactoryTransactionTypes[policy.Transaction.Type];
    // const programType = policy.Attributes.FormType || policy.Attributes.Lob;
    const programType = base.programTypeValue
      ? base.programTypeValue
      : policy.Attributes.FormType || policy.Attributes.Lob;
    const url = `${base.env.NEXT_PUBLIC_FORM_FACTORY_API_URL}ProductForm/${productCode}/${transactionType}/GET/${programType}`;

    // Get JWT token
    const loggedUser = base.getStoreState(base.storeKeys.LoggedInUserReducer);
    const JWT = loggedUser?.encodedJWT;

    const resp = await callAPI(url, 'GET', null, {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${JWT}`,
      'Ocp-Apim-Subscription-Key': base.env.APIM_SUBSCRIPTION_KEY,
    });
    return resp.length ? resp : [];
  } catch (error) {
    console.error('error: ', error);
    throw error;
  }
};
export const getChildLOBS = (key, value) => {
  const childLobs = getStoreState(storeKeys.ApplicationReducer).selectedBusinessLine.childLobs ?? [];
  switch (key) {
    case 'Lob': {
      const key = Object.keys(childLobs).find((key) => childLobs[key] === value);
      return key;
    }
    case 'LobDescription': {
      const description = childLobs[value];
      return description;
    }
    case 'LobList': {
      return childLobs;
    }
    default: {
      const keys = Object.keys(childLobs);
      return keys;
    }
  }
};

export const getRateSheetDetails = (model) => {
  const lob = model?.Attributes?.Lob;
  if (getChildLOBS().includes(lob)) {
    const templateName = `${lob}.html`;
    const fileName = `${lob}-RateSheet`;
    return { templateName: templateName, fileName: fileName };
  } else {
    const templateName = 'OR.html';
    const fileName = 'RateSheet';
    return { templateName: templateName, fileName: fileName };
  }
};

export const envs = {
  NEXT_PUBLIC_GQL_END_POINT:
    getCurrentLob() === 'CA' ? process.env.NEXT_PUBLIC_PROXY_GQL_END_POINT : process.env.NEXT_PUBLIC_GQL_END_POINT,
  NEXT_PUBLIC_FORM_FACTORY_API_URL: process.env.NEXT_PUBLIC_FORM_FACTORY_API_URL,
  NEXT_PUBLIC_DMS_API_NAME: process.env.NEXT_PUBLIC_DMS_API_NAME,
  NEXT_PUBLIC_DMS_CONTAINER_NAME: process.env.NEXT_PUBLIC_DMS_CONTAINER_NAME,
  NEXT_PUBLIC_DMS_API_BASE_URL: process.env.NEXT_PUBLIC_DMS_API_BASE_URL,
  NEXT_PUBLIC_DMS_API_POST_Upload_to_Blob: process.env.NEXT_PUBLIC_DMS_API_POST_UPLOAD_TO_BLOB,
  NEXT_PUBLIC_DMS_API_AUTH: process.env.NEXT_PUBLIC_DMS_API_AUTH,
  NEXT_PUBLIC_MASTER_DATA_URL: process.env.NEXT_PUBLIC_MASTER_DATA_URL,
  NEXT_PUBLIC_DMS_API_GET_DOC_LIST_RELATIVE_URL: process.env.NEXT_PUBLIC_DMS_API_GET_DOC_LIST_RELATIVE_URL,
  NEXT_PUBLIC_STORAGE_ACCOUNT: 'ctsdiep2devstorage',
  NEXT_PUBLIC_FORM_FACTORY_API_USERNAME: process.env.NEXT_PUBLIC_FORM_FACTORY_API_USERNAME,
  NEXT_PUBLIC_FORM_FACTORY_API_PASSWORD: process.env.NEXT_PUBLIC_FORM_FACTORY_API_PASSWORD,
  NEXT_PUBLIC_FORM_FACTORY_API_VALIDATION_METHOD: process.env.NEXT_PUBLIC_FORM_FACTORY_API_VALIDATION_METHOD,
  NEXT_PUBLIC_FORM_FACTORY_API_AUTHURL: process.env.NEXT_PUBLIC_FORM_FACTORY_API_AUTHURL,
  NEXT_PUBLIC_PROXY_GQL_END_POINT: process.env.NEXT_PUBLIC_PROXY_GQL_END_POINT,
};

export const getSummaryComponentPath = () => {
  const lob = getCurrentLob();
  if (lob === 'CA') {
    return `ui/components/commercial/auto/application/summary`;
  }
  return `ui/components/application/summary`;
};
export const dateFormatter = (date) => {
  const d = moment(date).format('MM/DD/YYYY');
  return d;
};

export const maskLicenseNumber = (licenseNumber) => {
  if (!licenseNumber) {
    return '';
  }
  const visiblePart = licenseNumber.slice(-4);
  const maskedPart = licenseNumber.slice(0, -4).replace(/./g, 'X');
  return maskedPart + visiblePart;
};

export const findGaragingLocationCoordinates = (policy) => {
  // Access the Locations array safely
  const locations = policy?.InsuredAccount?.BusinessInfo?.Locations || [];

  // Filter for locations with Address.Description equal to "Garaging Address"
  const garagingLocations = locations.filter((location) => location?.Address?.Description === 'Garaging Address');

  if (garagingLocations.length === 0) {
    // No garaging address found, return null or handle as needed
    return null;
  }

  // Check if any of the filtered locations has LocationNumber === 0
  const locationWithZero = garagingLocations.find((location) => location.LocationNumber === 0);

  // Select the location with LocationNumber 0, if available; otherwise, take the first garaging location
  const selectedLocation = locationWithZero || garagingLocations[0];

  // Return an object with only Long and Lat from the selected location's address
  return {
    Long: selectedLocation?.Address?.Long || 0,
    Lat: selectedLocation?.Address?.Lat || 0,
  };
};

export const errorMessage = (model, isAgent = true, showToast = true, uwRuleMessagesToCheck = null) => {
  let message = '';
  let priority = '';
  if (model?.RatingErrors && model.RatingErrors?.length > 0) {
    message = model.RatingErrors[0].message;
  } else if (model?.CustomMessage && model.CustomMessage?.length > 0) {
    message = model?.CustomMessage[0].Message;
    priority = model?.CustomMessage[0].Priority;
  } else if (model?.CustomErrors && model.CustomErrors?.length > 0) {
    message = model?.CustomErrors[0].message;
    priority = model?.CustomErrors[0].priority;
  } else if (model?.Rules?.MatchingRules && model.Rules.MatchingRules?.length > 0) {
    message = model?.Rules?.MatchingRules[0].Reason;
    if (
      uwRuleMessagesToCheck &&
      model?.Rules?.MatchingRules.some((rule) => uwRuleMessagesToCheck.includes(rule?.Reason))
    ) {
      priority = 50;
    }
    if (message.toLowerCase().includes('ofac')) {
      message = alertMsgs.ToasterMsg.ReferToUW;
    }
  }
  if (message.length > 0) {
    nProgress.start();
    isAgent && showToast && toast.error(message);
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve(priority);
      }, 5000); // 5 second delay
    });
  } else {
    return priority;
  }
};

export const processPayload = (payload) => {
  // Extract the keys from the payload

  const { model, schema, state, setState, ...rest } = payload;

  const sanitizeModel = (sourceModel) => {
    if (!sourceModel) {
      return sourceModel;
    }
    const cloned = structuredClone(sourceModel);

    if (
      cloned.NonFunctional &&
      Object.prototype.hasOwnProperty.call(cloned.NonFunctional, 'WaiveFilingFeeInitialized')
    ) {
      const { WaiveFilingFeeInitialized, ...restNonFunctional } = cloned.NonFunctional;
      cloned.NonFunctional = restNonFunctional;
    }

    if (cloned.Attributes?.Lob === 'PP') {
      stripPayrollProtectionRiskQualifiersUiFields(cloned);
    }

    return cloned;
  };

  // Check if the payload has only the 4 default keys
  const isDefaultPayload = Object.keys(rest).length === 0;

  // If it only has model, schema, state, setState, return { ...model }
  if (isDefaultPayload) {
    return sanitizeModel(model);
  }

  // If there are additional keys, return the original payload
  return { model: sanitizeModel(model), schema, state, setState, ...rest };
};

export const isIntegrationActive = (key = 'DDM') => {
  try {
    const tableList = getStoreState(storeKeys.DataReducer)?.roleAuthorization?.Integrations;
    const masterReducer = getStoreState(storeKeys.MasterReducer)?.Integrations;
    const isActive = masterReducer?.find((item) => item.IntegrationName === tableList?.[key]?.value)?.Enabled;
    return isActive;
  } catch (error) {
    console.error(error);
  }
};
/**
 * Checks if the logged-in user is active based on their role type.
 *
 * @param {string} loggedInUser - The username of the currently logged-in user.
 * @param {Object} data - The data object containing user status information.
 * @param {string} type - The role type of the user, e.g., 'Agent' or 'UnderWriter'.
 * @returns {Promise<boolean>} - Returns a promise that resolves to true if the user is active, otherwise false.
 * Logs out the user if they are not active and displays an error message on failure.
 */
export const checkIsActiveUser = async (loggedInUser, data, type) => {
  try {
    const isActiveUser = (() => {
      switch (type) {
        case commonKeys.RoleAgent:
          return data?.PolicyDetails?.Agent?.Status === 'Active';
        case commonKeys.RoleUnderwriter:
          return data?.PolicyDetails?.Underwriter?.Status === 'Active';
        default:
          return true;
      }
    })();

    if (!isActiveUser) {
      logoutUser();
    }
    return isActiveUser;
  } catch (error) {
    console.error('Utilities.Helpers.CheckIsActiveUser:: ', error);
    toast.error(alertMsgs.ToasterMsg.SomethingWentWrong);
    return false;
  }
};

export const getLoggedInUserRole = () => {
  const currentLoginState = getStoreState(storeKeys.LoggedInUserReducer);
  return currentLoginState?.decodedJWT?.role.split(',').length > 1
    ? currentLoginState?.decodedJWT?.role.split(',').pop()
    : currentLoginState?.decodedJWT?.role;
};

export const getLoggedInUserName = () => {
  const currentLoginState = getStoreState(storeKeys.LoggedInUserReducer);
  return `${currentLoginState?.decodedJWT?.FirstName} ${currentLoginState?.decodedJWT?.LastName}`;
};

export const getLoggedInNameCode = () => {
  const currentLoginState = getStoreState(storeKeys.LoggedInUserReducer);
  return currentLoginState?.decodedJWT?.Username;
};
export const getLoginUserName = (userObj = null) => {
  const currentLoginState = userObj ?? getStoreState(storeKeys.LoggedInUserReducer);
  return currentLoginState?.decodedJWT?.Username;
};

export const getLoginUserRole = (userObj = null) => {
  const currentLoginState = userObj ?? getStoreState(storeKeys.LoggedInUserReducer);
  const Role = currentLoginState?.decodedJWT?.role.split(',').pop();
  return Role.toLowerCase().includes('underwriter') ? commonKeys.RoleUnderwriter : commonKeys.RoleAgent;
};

export const checkDDMUnderWriterRole = (data) => {
  try {
    const currentUserName = getLoginUserName();
    const underWriterDetails = data?.MasterUW?.find((data) => data.UserLogin === currentUserName)?.Role;
    return underWriterDetails;
  } catch (error) {
    console.error('internalConsoleLogs.Utilities.Helper.CheckDDMUnderWriterRole', error);
    toast.error(alertMsgs.ToasterMsg.SomethingWentWrong);
  }
};

export const onSearchUserDDMV2 = async (SearchText = '', Target = 'Underwriter', ResponseExpression = '') => {
  try {
    const payload = {
      SearchText,
      Target: [Target],
      Status: 'Active',
      ResponseExpression: ResponseExpression
        ? ResponseExpression
        : '{"Agency":Agency[].{"key":id,"label":DBAName,"value":BrokerCode},"Agent":Agent[].{"key":id,"label":Name,"value":UserLogin,"NPN":NPN?NPN:"","UserLogin":UserLogin},"Underwriter":Underwriter[].{"key":id,"label":Name,"value":UserId,"Name":Name,"Code":UserId,"UserLogin":UserLogin,"UserId":UserId, "Role":Role}}',
      ProductName: process.env.NEXT_PUBLIC_CLIENT,
    };
    const loggedInUser = getStoreState(storeKeys.LoggedInUserReducer);
    const headers = {
      'Ocp-Apim-Subscription-Key': process.env.NEXT_PUBLIC_OCP_APIM_SUBSCRIPTION_KEY,
      Authorization: `Bearer ${loggedInUser.encodedJWT}`,
    };

    const apiUrl = `${process.env.NEXT_PUBLIC_ADAPTIVE_API_BASE_URL}${process.env.NEXT_PUBLIC_SEARCH_BY_TARGET_V2_URL}`;
    const response = await callAPI(axiosKeys.PostAction, apiUrl, payload, headers);

    const users = response?.Output?.[Target] ?? [];
    return Array.isArray(users) ? users : [users];
  } catch (error) {
    console.error('Error in onSearchUserDDMV2', JSON.stringify(error));
    toast.error(alertMsgs.ToasterMsg.SomethingWentWrong);
    throw error;
  }
};

export const fetchUserInformationDetails = async () => {
  const currentLoginUser = getLoginUserRole();
  try {
    const userName = getLoginUserName();
    const lowerCaseRole = currentLoginUser.toLowerCase();

    const initialData = getStoreState(storeKeys.DataReducer).initialData;

    if (lowerCaseRole === commonKeys.RoleAgent.toLowerCase()) {
      // Agent role logic
      const payload = {
        userid: userName,
        role: currentLoginUser,
        ProductName: process.env.NEXT_PUBLIC_CLIENT,
      };
      const apiUrl = `${process.env.NEXT_PUBLIC_ADAPTIVE_URL}${process.env.NEXT_PUBLIC_CTS_AGENT_USER_INFORMATION_URL}`;
      const loggedInUser = getStoreState(storeKeys.LoggedInUserReducer);
      const headers = {
        'Ocp-Apim-Subscription-Key': process.env.NEXT_PUBLIC_OCP_APIM_SUBSCRIPTION_KEY,
        Authorization: `Bearer ${loggedInUser.encodedJWT}`,
      };

      const { Output } = await callAPI(axiosKeys.PostAction, apiUrl, payload, headers);
      //await checkIsActiveUser(userName, Output, commonKeys.Agent);
      // Extract additional agent details
      const agencyDetails = Output?.PolicyDetails?.Agency;
      const agentDetails = Output?.PolicyDetails?.Agent;
      // setRestrictionsDetailsStateDDM(Output?.AgentRestrictionsDetails);
      // setPermissionState(Output?.PolicyDetails?.Agent.Code);

      const initialDataUpdate = {
        ...initialData,
        Agency: agencyDetails ? { ...agencyDetails, Address: agencyDetails?.Address } : { ...initialData?.Agency },
        Agent: agencyDetails ? { ...agentDetails } : { ...initialData?.Agent },
      };

      setInitialState(initialDataUpdate);
      setStoreState(storeKeys.PolicyReducer, initialDataUpdate);
      return { agencyDetails, agentDetails };
    } else if (lowerCaseRole === commonKeys.RoleUnderwriter.toLowerCase()) {
      // Underwriter role logic
      NProgress.start();
      const payload = {
        userid: userName,
        role: currentLoginUser,
        ProductName: process.env.NEXT_PUBLIC_CLIENT,
      };
      const apiUrl = `${process.env.NEXT_PUBLIC_ADAPTIVE_URL}${process.env.NEXT_PUBLIC_CTS_UW_USER_INFORMATION_URL}`;
      const loggedInUser = getStoreState(storeKeys.LoggedInUserReducer);
      const headers = {
        'Ocp-Apim-Subscription-Key': process.env.NEXT_PUBLIC_OCP_APIM_SUBSCRIPTION_KEY,
        Authorization: `Bearer ${loggedInUser.encodedJWT}`,
      };

      const { Output } = await callAPI(axiosKeys.PostAction, apiUrl, payload, headers);
      await checkIsActiveUser(userName, Output, commonKeys.UnderWriter);
      NProgress.done();

      let underwriterDetails = null;
      const isUWHasAdminRole = false;

      const DDMUnderWriterUserInformation = Output;
      underwriterDetails = DDMUnderWriterUserInformation?.PolicyDetails?.UnderWriter;

      setInitialState({
        ...initialData,
        UnderWriter: underwriterDetails
          ? {
              ...initialData?.UnderWriter,
              Code: underwriterDetails.Code,
              Name: underwriterDetails.Name,

              Details: { ...underwriterDetails?.Details },
              Status: underwriterDetails?.Status,
              Reference: underwriterDetails?.Reference,
              Address: underwriterDetails?.Address,
              Role: underwriterDetails?.Role,
            }
          : { ...initialData?.UnderWriter },
      });

      return { underwriterDetails, isUWHasAdminRole };
    } else {
      throw new Error('Unsupported user role');
    }
  } catch (error) {
    // Ensure NProgress is stopped for underwriter errors
    if (currentLoginUser && currentLoginUser.toLowerCase() === commonKeys.RoleUnderwriter.toLowerCase()) {
      NProgress.done();
    }
    console.error('Error in fetchUserInformationDetails', error);
    toast.error(alertMsgs.ToasterMsg.SomethingWentWrong);
  }
};

export const setRestrictionsDetailsStateDDM = (RestrictionsDetails) => {
  const ApplicationReducer = getStoreState(storeKeys.ApplicationReducer);

  if (RestrictionsDetails) {
    setStoreState(storeKeys.ApplicationReducer, {
      ...ApplicationReducer,

      DDM: {
        ...ApplicationReducer.DDM,
        RestrictionsDetails: [...RestrictionsDetails],
      },
    });
  }
};

export const setInitialState = (initialData) => {
  const DataReducer = getStoreState(storeKeys.DataReducer);

  setStoreState(storeKeys.DataReducer, {
    ...DataReducer,

    initialData: {
      ...initialData,
    },
  });
};

const getAgencyPolicesClause = (input, code, expression) => {
  if (Array.isArray(code)) {
    code.forEach((c) => {
      input.input.clause.push({
        src: 'c.Agency.Code',
        def: `'${c}'`,
        exp: expression,
        operator: 'OR',
      });
    });
  } else {
    input.input.clause.push({
      src: 'c.Agency.Code',
      def: `'${code}'`,
      exp: expression,
      operator: 'AND',
    });
  }
  return input;
};

export const DDMSpecialClause = (input) => {
  const currentLoginUser = getLoginUserRole();
  const initialData = getStoreState(storeKeys.PolicyReducer);
  const agencyCode = initialData?.Agency?.Code;
  const underWriterCode = initialData?.UnderWriter?.Reference;
  if (initialData) {
    const roleMapping = {
      [commonKeys.RoleAgent.toLowerCase()]: agencyCode,
    };
    const code = roleMapping[currentLoginUser.toLowerCase()];
    if (code) {
      input = getAgencyPolicesClause(input, code, '=');
    }
  }

  return input;
};

export const onSearchAgencyAgentUWDDM = async (
  target,
  SearchText = '',
  useResponseExpression = false,
  brokerCode = '',
  expression
) => {
  try {
    const role = getLoginUserRole();
    const userId = getLoginUserName();
    const responseExpression = useResponseExpression
      ? expression
        ? expression
        : '{\r\n  \r\n  "Agency": Agency[].{\r\n    "key": id,\r\n      "label": BrokerCode & " - " & DBAName & " - " & Address.City,\r\n        "value":BrokerCode\r\n  },\r\n\r\n  "Agent": Agent[].{ \r\n    \r\n     "key": id,\r\n      "label": Name & " - " & Communications[Type="Email"].Value ,\r\n        "value":UserLogin\r\n    },\r\n    "Underwriter": Underwriter[].{ \r\n         "key": id,\r\n      "label": Name,\r\n        "value":UserLogin\r\n      }\r\n}'
      : '';
    const payload = {
      Filter: {
        BrokerCode: brokerCode,
      },
      Target: Array.isArray(target) ? [...target] : [target],
      ResponseExpression: responseExpression,
      SearchText: SearchText,
      ProductName: process.env.NEXT_PUBLIC_CLIENT,
      Role: role,
      UserId: userId,
    };
    const loggedInUser = getStoreState(storeKeys.LoggedInUserReducer);
    const headers = {
      'Ocp-Apim-Subscription-Key': process.env.NEXT_PUBLIC_OCP_APIM_SUBSCRIPTION_KEY,
      ProductName: process.env.NEXT_PUBLIC_CLIENT,
      Authorization: `Bearer ${loggedInUser.encodedJWT}`,
    };
    const apiUrl = `${process.env.NEXT_PUBLIC_ADAPTIVE_API_BASE_URL}${process.env.NEXT_PUBLIC_SEARCH_BY_TARGET_URL}`;
    const response = await callAPI(axiosKeys.PostAction, apiUrl, payload, headers);
    return response.Output;
  } catch (error) {
    console.error('Error in onSearchAgencyAgentUWDDM', error);
    toast.error(alertMsgs.ToasterMsg.SomethingWentWrong);
  }
};

export const onSearchUnifiedDDM = async (
  role, // 'Underwriter' | 'Agent' | 'Agency'
  dynamicPayload // Object containing the required dynamic key/value per role
) => {
  try {
    // Start progress indicator
    nProgress.start();

    // Retrieve the logged-in user details for the authorization header.
    const loggedInUser = getStoreState(storeKeys.LoggedInUserReducer);
    const headers = {
      'Content-Type': 'application/json',
      'Ocp-Apim-Subscription-Key': process.env.NEXT_PUBLIC_ADAPTIVE_SUBSCRIPTION_KEY.toLocaleLowerCase(),
      Authorization: `Bearer ${loggedInUser.encodedJWT}`,
    };

    // Base payload with a common property
    let payload = { ProductName: process.env.NEXT_PUBLIC_CLIENT };
    let requestURL = '';
    switch (role.toLowerCase()) {
      case 'underwriter':
        // Check if dynamic payload contains required property
        if (!dynamicPayload || !dynamicPayload.UserLogin) {
          toast.error('Missing required payload value for Underwriter: userlogin');
          nProgress.done();
          return;
        }
        requestURL = `${process.env.NEXT_PUBLIC_ADAPTIVE_API_BASE_URL}${process.env.NEXT_PUBLIC_CTS_GET_PARTICULAR_UW_DETAILS_URL}`;

        payload = {
          ...payload,
          UserLogin: dynamicPayload.UserLogin,
          Role: role,
        };
        break;
      case 'agent':
        if (!dynamicPayload || !dynamicPayload.UserId) {
          toast.error('Missing required payload value for Agent: UserId');
          nProgress.done();
          return;
        }
        requestURL = `${process.env.NEXT_PUBLIC_ADAPTIVE_API_BASE_URL}${process.env.NEXT_PUBLIC_CTS_GET_PARTICULAR_AGENT_DETAILS_URL}`;
        payload = { ...payload, UserId: dynamicPayload.UserId, Role: role };
        break;
      case 'agency':
        if (!dynamicPayload || !dynamicPayload.BrokerCode) {
          toast.error('Missing required payload value for Agency: BrokerCode');
          nProgress.done();
          return;
        }
        requestURL = `${process.env.NEXT_PUBLIC_ADAPTIVE_API_BASE_URL}${process.env.NEXT_PUBLIC_CTS_GET_PARTICULAR_AGENCY_DETAILS_URL}`;
        payload = {
          ...payload,
          BrokerCode: dynamicPayload.BrokerCode,
          Role: role,
        };
        break;
      default:
        toast.error('Invalid role specified. Expected Underwriter, Agent, or Agency.');
        nProgress.done();
        return;
    }
    const apiResponse = await callAPI(axiosKeys.PostAction, requestURL, payload, headers);
    nProgress.done();

    return apiResponse.Output.PolicyDetails;
  } catch (error) {
    console.error(`Error in onSearchUnifiedDDM for role: ${role}`, error);
    nProgress.done();
    toast.error(alertMsgs.ToasterMsg.SomethingWentWrong);
    throw error;
  }
};

export const fetchPermissionDetails = () => {
  return getStoreState(storeKeys.ApplicationReducer)?.DDM?.UserDDMPermission;
};

export const extractOptionsByKey = (schemaArray, parentKey, controlKey) => {
  if (!schemaArray || !Array.isArray(schemaArray)) {
    return new Map();
  }

  // Flatten the nested schema array
  const flatSchema = schemaArray.flat();

  // Find the parent object with key equal to parentKey
  const parentObj = flatSchema.find((item) => item.key === parentKey);
  if (!parentObj || !Array.isArray(parentObj.controls)) {
    return new Map();
  }

  // Find the control with key equal to controlKey
  const control = parentObj.controls.find((ctrl) => ctrl.key === controlKey);

  // If control found and it has an options array, map it to a Map with each option's key as index.
  const options = control && Array.isArray(control.options) ? control.options : [];
  return new Map(options.map((option) => [option.key, option]));
};

export const updateCurrentUISchema = (payload) => {
  const schema = getStoreState(storeKeys.SchemaReducer);

  setStoreState(storeKeys.SchemaReducer, {
    ...schema,
    currentSchema: {
      ...schema.currentSchema,
      ...payload,
    },
  });
};

export const getDDMLobsToselect = () => {
  const config = getStoreState(storeKeys.ApplicationReducer).selectedBusinessLine;

  const { line, lob, state, carrier, version } = config;

  const lobSpecificData = getStoreState(storeKeys.SchemaReducer)?.[line]?.[lob]?.[state]?.[carrier]?.[version];
  const lobsToSelect = lobSpecificData?.quote?.[0]?.Blob?.LobsToSelect;

  return lobsToSelect;
};

export const _isAgentLoggedIn = () => {
  const currentLoginUser = getLoginUserRole(false);
  return currentLoginUser.toLowerCase() === commonKeys.RoleAgent.toLowerCase();
};

export const getMatchingPermissions = (listOfCarriersResponse, policyData) => {
  const { UserDDMPermission = [], RestrictionsDetails = [] } = getStoreState(storeKeys.ApplicationReducer)?.DDM || {};
  const { State: policyState, Lob: policyLob } = policyData?.Attributes || {};
  const currentDate = new Date();

  // If there are no permission, return empty []
  if (UserDDMPermission.length === 0) {
    return [];
  }

  // 🎯 Filter permission restrictions relevant to this policy
  const matchingPermissionsCarrier = [];
  UserDDMPermission.find(({ StateCode, LobCode, AsOfDate, ExpiryDate, IsActive, CarrierCode }) => {
    if (
      IsActive &&
      StateCode === policyState &&
      LobCode === policyLob &&
      new Date(AsOfDate) <= currentDate &&
      (!ExpiryDate || new Date(ExpiryDate) >= currentDate)
    ) {
      matchingPermissionsCarrier.push(CarrierCode);
    }
  });

  const filteredPermissionCarrier = listOfCarriersResponse.filter(({ Attributes: { Carrier } }) =>
    matchingPermissionsCarrier.includes(Carrier)
  );

  if (matchingPermissionsCarrier.length === 0) {
    return filteredPermissionCarrier;
  }

  // ✅ If there are no restrictions, return all carriers
  if (RestrictionsDetails.length === 0) {
    return filteredPermissionCarrier;
  }

  // 🎯 Filter restrictions relevant to this policy
  const matchingRestrictions = RestrictionsDetails.filter(
    ({ State, LOB, EffectiveDate, ExpiryDate }) =>
      State.includes(policyState) &&
      LOB.includes(policyLob) &&
      new Date(EffectiveDate) <= currentDate &&
      (!ExpiryDate || new Date(ExpiryDate) >= currentDate)
  );

  // 🔒 Extract restricted carriers from matching restrictions
  const restrictedCarriers = new Set(
    matchingRestrictions.flatMap(({ Carrier }) => Carrier?.map(({ CarrierName }) => CarrierName) || [])
  );

  // ✅ Final list = all carriers EXCEPT the restricted ones
  const filteredCarriers = filteredPermissionCarrier.filter(
    ({ Attributes: { RaterCarrier } }) => !restrictedCarriers.has(RaterCarrier)
  );

  if (filteredCarriers.length === 0) {
    return [];
  }

  return filteredCarriers;
};

export const resetDetails = () => {
  resetPolicy(getInitialState());
};

export const commonAgencyDetails = (c, dataModel) => {
  const hasDDM = isDDMIntegrationActive();
  const User = getStoreState(storeKeys.LoggedInUserReducer);
  const Roles = User.decodedJWT.role;
  const agencyCode = dataModel?.Agency?.Code;
  const agencyName = dataModel?.Agency?.Name;
  const agencyAddress = dataModel?.Agency?.Address;
  if (!hasDDM) {
    c.options = getUsersData('agencies', false);
    if (Roles === 'Agent') {
      c.props.disabled = 'true';
    }
  } else {
    c.options = [
      {
        key: agencyCode,
        label: agencyName
          ? `${agencyCode} - ${agencyName}, ${agencyAddress?.City}, ${agencyAddress?.State}`
          : 'Select...',
        value: agencyCode,
      },
    ];
    c.props.disabled = 'true';
  }
  return c;
};

export const replaceData = (initialData, isRenewal) => {
  return [
    {
      key: '"$STATUS_OPTIONS$"',
      value: statusOptions(isRenewal ? RenewalsPolicyStatusMaster : PolicyStatusMaster),
    },
    {
      key: '"$DATE$"',
      value: new Date(),
    },
    {
      key: '"$LOBS_OPTIONS$"',
      value: initialData?.Attributes?.LobsArr,
    },
    // {
    //   key: '"$CURRENCYFORMAT$"',
    //   value: currencyFormat,
    // },
    {
      key: '"$STATES_OPTIONS$"',
      value: initialData?.Attributes?.StatesArr,
    },
  ];
};
export const isRoleAgent = (loggedInUserDetails) =>
  commonKeys.AgentRoles.includes(loggedInUserDetails?.decodedJWT?.role);

export const loadQuoteDetail = async (quoteNumber, quoteVersion) => {
  const input = {
    input: {
      clause: [
        {
          src: 'r.QuoteNumber',
          def: "'" + quoteNumber + "'",
          exp: '=',
          operator: 'AND',
        },
        {
          src: 'r.QuoteVersion',
          def: "'" + quoteVersion + "'",
          exp: '=',
          operator: 'AND',
        },
        {
          src: 'r.Attributes.Client',
          def: "'" + process.env.NEXT_PUBLIC_CLIENT + "'",
          exp: '=',
          operator: 'AND',
        },
      ],
      containerName: 'policy',
    },
  };
  const gqlEndPoint = process.env.NEXT_PUBLIC_GQL_END_POINT;
  const queries = getStoreState(storeKeys.QueriesReducer);
  const res = await executeQuery(getApolloClient(gqlEndPoint), GRAPHQL_QUERIES(queries, 'GET_POLICY', []), input);
  return res.data[apolloKeys.GetByFilter]?.length > 0 ? res.data[apolloKeys.GetByFilter][0] : null;
};

export const redirectLogin = (router) => router.push(process.env.NEXT_PUBLIC_PROJECT_URL + '/cogitate');

export const currencyFormatAccountHub = (num) => {
  try {
    if (typeof num == 'string' && num.length > 0) {
      num = num.replace(',', '');
    }
    if (typeof num === 'string' && num.includes('/')) {
      const parts = num.split('/');
      const left = parts[0].trim();
      const right = parts[1].trim();
      const leftFormatted = parseFloat(left)
        .toFixed(2)
        .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
      const rightFormatted = parseFloat(right)
        .toFixed(2)
        .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
      return `$${leftFormatted} / $${rightFormatted}`;
    }
    if (parseInt(num) == 0 || (num && !isNaN(num) && isFinite(num))) {
      num = num.toString();
      return (
        '$' +
        parseFloat(num)
          .toFixed(2)
          .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
      );
    } else return '$0.00';
  } catch (error) {
    console.error('Utilities.Helpers.Shared.CurrencyFormat ', error);
    throw Error();
  }
};

export const claimColumns = [
  {
    dataField: 'ClaimNumber',
    text: 'Claim Number',
    sort: false,
    formatter: (cell) => {
      return cell || '--';
    },
    headerStyle: () => ({ textAlign: 'center' }),
    style: () => ({ textAlign: 'center' }),
  },
  {
    dataField: 'Status',
    text: 'Status',
    sort: false,
    formatter: (cell) => {
      return cell || '--';
    },
    headerStyle: () => ({ textAlign: 'center' }),
    style: () => ({ textAlign: 'center' }),
  },
  {
    dataField: 'LossDate',
    text: 'Date Of Loss',
    sort: false,
    formatter: (cell) => {
      return dateFormatterNew(cell?.split('T')[0]) || '--';
    },
    headerStyle: () => ({ textAlign: 'center' }),
    style: () => ({ textAlign: 'center' }),
  },
  {
    dataField: 'MainAdjusterName',
    text: 'Adjuster Name',
    sort: false,
    formatter: (cell) => {
      return cell || '--';
    },
    headerStyle: () => ({ textAlign: 'center' }),
    style: () => ({ textAlign: 'center' }),
  },
  {
    dataField: 'Phone',
    text: 'Adjuster Phone Number',
    sort: false,
    formatter: (cell) => {
      return phoneNumberFormat(cell) || '--';
    },
    headerStyle: () => ({ textAlign: 'center' }),
    style: () => ({ textAlign: 'center' }),
  },
  {
    dataField: 'Email',
    text: 'Adjuster Email Id',
    sort: false,
    formatter: (cell) => {
      return cell || '--';
    },
    headerStyle: () => ({ textAlign: 'center' }),
    style: () => ({ textAlign: 'center' }),
  },
  {
    dataField: 'PaidLoss',
    text: 'Paid Loss',
    sort: false,
    formatter: (cell) => {
      return currencyFormat(cell) || '--';
    },
    headerStyle: () => ({ textAlign: 'center' }),
    style: () => ({ textAlign: 'center' }),
  },
];

export const getCurrentUserRole = () => {
  const userData = getStoreState(storeKeys.LoggedInUserReducer)?.decodedJWT;
  const role = userData?.role;
  if (!role) {
    return role;
  }
  return role.split(',').pop();
};

export const routerLanding = (router, route) => {
  router.push(route);
};

export const getAccountHubPremium = (policy) => {
  let premium = policy?.TotalPremium?.CumulativePremiumWithFeesAndTaxes;
  // if (policy.TransactionHistory.length > 0) {
  //   premium = policy.TransactionHistory.at(-1)?.AnnualPremiumWithFeesAndTaxes;
  // } else premium = policy.TotalPremium?.AnnualPremiumWithFeesAndTaxes;
  return currencyFormatAccountHub(premium);
};

export const getLimitAndPremium = (policyData, planName, fieldName) => {
  return currencyFormatWithoutDecimal(
    policyData.Risks.PayrollProtectionUnit[0].PremiumFactors.find((factor) => factor.Name.includes(planName))?.[
      fieldName
    ],
    '--'
  );
};
